import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 24px;
  color: #1a1a2e;
`;

export const Toolbar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
`;

export const BillingTabsRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const BillingTabButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  border: 1px solid ${(props) => (props.$active ? "#3fc4fd" : "#dce1e8")};
  background: ${(props) => (props.$active ? "#e9f9ff" : "#ffffff")};
  color: ${(props) => (props.$active ? "#1381c5" : "#555")};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

export const SectionCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 20px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #1a1a2e;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
`;

export const SummaryCard = styled.div`
  background: #f8fafd;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 16px;
`;

export const SummaryLabel = styled.div`
  font-size: 13px;
  color: #838894;
  margin-bottom: 6px;
`;

export const SummaryValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f8fafd;
  border: 1px solid #eef2f7;
`;

export const DetailLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #838894;
  text-transform: uppercase;
`;

export const DetailValue = styled.span`
  font-size: 15px;
  color: #1a1a2e;
  word-break: break-word;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  &.full {
    grid-column: 1 / -1;
  }
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #555;

  &.required::after {
    content: " *";
    color: #d32f2f;
  }
`;

export const FormInput = styled.input`
  padding: 10px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  background: #fff;
  outline: none;

  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(63, 196, 253, 0.12);
  }

  &:disabled {
    background: #f5f7fa;
    color: #888;
  }
`;

export const FormSelect = styled.select`
  padding: 10px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  background: #fff;
  outline: none;

  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(63, 196, 253, 0.12);
  }
`;

export const FormTextArea = styled.textarea`
  padding: 12px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  background: #fff;
  resize: vertical;
  min-height: 92px;
  outline: none;
  font-family: inherit;

  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(63, 196, 253, 0.12);
  }
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: ${(props) => (props.$error ? "#d32f2f" : "#838894")};
`;

export const CheckboxRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
`;

export const FeatureList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FeatureChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf7ff;
  border: 1px solid #d7ebf7;
  color: #1381c5;
  font-size: 12px;
  font-weight: 600;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  padding: 6px 12px;
  border-radius: 999px;
  background: ${(props) => props.$background || "#eef2f7"};
  color: ${(props) => props.$color || "#555"};
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  background: #3fc4fd;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  background: #ffffff;
  color: #1381c5;
  border: 1px solid #cfe9f7;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

export const DangerButton = styled(SecondaryButton)`
  color: #c62828;
  border-color: #f3c3c3;
  background: #fff7f7;
`;

export const ModalBody = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
`;

export const StateCard = styled(SectionCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 180px;
  text-align: center;
`;

export const StateTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
`;

export const StateText = styled.div`
  max-width: 420px;
  font-size: 14px;
  color: #6c7480;
  line-height: 1.5;
`;
